export enum BSAEnv {
  DV = 'dv',
  QA = 'qa',
  PP = 'pp',
  PD = 'pd',
}

export enum RankStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum UnparsedBoolean {
  False = 'False',
  True = 'True',
}

/**
 * Used in some den endpoints where the person is inside a Den subunit
 */
export enum DenType {
  LION = 'lions',
  BOBCAT = 'bobcat',
  TIGER = 'tigers',
  WOLF = 'wolves',
  BEAR = 'bears',
  WEBELOS = 'webelos',
  AOL = 'aol',
}

/**
 * Payment logs lookup types
 */
export enum PaymentTypes {
  CREDIT = 'Credit',
  PAYMENT = 'Payment',
  CHARGE = 'Charge',
  DEBIT = 'Debit',
}

/**
 * Payment logs status types
 */
export enum PaymentStatus {
  DUE = 'due',
  PAST_DUE = 'past-due',
}

/**
 * Payment logs sources for create request
 */
export enum PaymentSources {
  USER = 'User',
  UNIT = 'Unit',
}

/**
 * IDs of Relationship types got from /lookups/person/relationshipTypes
 */
export enum PersonRelationShipType {
  FatherOf = 1,
  MotherOf = 2,
  SonOf = 3,
}

export enum UnitStatus {
  Active = 'active',
  Lapsed = 'lapsed',
  Expired = 'expired',
  All = 'all',
  Unposted = 'Unposted',
}

export enum AdvancementStatus {
  Awarded = 'Awarded',
  LeaderApproved = 'Leader Approved',
  Completed = 'Completed',
  Started = 'Started',
}

/** Used on pending items status */
export enum PendingItemStatus {
  STARTED = 'Started',
  LEADER_SIGNED = 'LeaderSigned',
  COUNSELOR_APPROVED = 'CounselorApproved',
  LEADER_APPROVED = 'LeaderApproved',
  COMPLETED = 'Completed',
  AWARDED = 'Awarded',
}

/** Used on merit badges blue card */
export enum BlueCardAdvancementStatus {
  STARTED = 'Started',
  LEADER_SIGNED = 'Leader Signed',
  COMPLETED = 'Completed',
  COUNSELOR_APPROVED = 'Counselor Approved',
  LEADER_APPROVED = 'Leader Approved',
  AWARDED = 'Awarded',
}

export enum PendingItemType {
  MERIT_BADGES = 'meritBadges',
  RANKS = 'ranks',
  AWARDS = 'awards',
  ADVENTURES = 'adventures',
  ACTIVITIES = 'activities',
}

export enum Gender {
  F = 'F',
  M = 'M',
}

/**
 * (2024-10-16) Computed by ESB
 */
export enum RenewalStatus {
  Expired = 'Expired',
  OptedOut = 'Opted Out',
  Renewed = 'Renewed',
  Eligible = 'Eligible to Renew',
  Current = 'Current',
  /*Custom value for this app only, means that the user doesn't have an entry in the /org<Adult|Youth|Parent> API*/
  NeedsToRegister = 'Needs to Register',
}

export enum RegistrationSituationStatus {
  Expired = 'expiredRegistration',
  Lapsed = 'lapsedRegistration',
  Active = 'activeRegistration',
}

export enum ProfileAttributes {
  Phone = 'phone',
  Address = 'address',
  Email = 'email',
  WebContact = 'webContact',
  Handicap = 'handicap',
  SpecialNeeds = 'specialNeeds',
  Religion = 'religion',
  Hobbies = 'hobbies',
  Education = 'education',
  MyBio = 'myBio',
  Employer = 'employer',
  Grade = 'grade',
}

export enum RenewalOrderStatus {
  Initiated = 'Initiated', // 1,
  Submitted = 'Submitted', // 2,
  Declined = 'Declined', // 3,
  Closed = 'Closed', // 4,
  Completed = 'Completed', // 5,
  PendingApproval = 'PendingApproval', // 6,
  /** Only used in the UI for catching unknown status */
  NotStarted = 'NotStarted',
}

export enum CustomReportDisplayMode {
  MyReports = '1',
  IncludeSharedReports = '3',
}
